import { render, staticRenderFns } from "./NavigationSegment.vue?vue&type=template&id=18524366&"
import script from "./NavigationSegment.vue?vue&type=script&lang=js&"
export * from "./NavigationSegment.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSegment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports